module.exports = __webpack_public_path__ + "img/axel2.560d9a96.jpeg";